import { FC, ReactNode, useState } from 'react';
import { NavLink } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import menuItems from '../../constants/menuItems';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Typography from '@mui/material/Typography';
import styles from './navStyles';

const AppDrawer: FC<{ children: ReactNode; rightLinkSlot?: ReactNode }> = ({
  children,
  rightLinkSlot,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const list = () => (
    <Box onClick={() => setOpen(false)} onKeyDown={() => setOpen(false)}>
      <List>
        <ListItem>
          <Typography variant="h5" sx={styles.titleLogo}>
            ALEJO.
          </Typography>
        </ListItem>
        {menuItems.map((item) => (
          <ListItem button key={item.route}>
            <NavLink
              to={item.route}
              state={{ categoryId: item?.category }}
              style={({ isActive }) =>
                isActive ? styles.selectedListItem : styles.navLink
              }
            >
              <ListItemText primary={item.title} />
            </NavLink>
          </ListItem>
        ))}
        {children && <ListItem>{children}</ListItem>}
      </List>
    </Box>
  );

  return (
    <Box display="flex" alignItems="center" sx={styles.container}>
      <IconButton onClick={() => setOpen(true)} aria-label="open menu">
        {open ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
      <Typography variant="h5" sx={styles.titleLogo} marginLeft="10px">
        ALEJO.
      </Typography>
      <SwipeableDrawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        sx={styles.drawer}
      >
        {list()}
      </SwipeableDrawer>
      <Box sx={{ flex: 1 }}>{rightLinkSlot}</Box>
    </Box>
  );
};

export default AppDrawer;
